/**
 * WHF Theme — Main JavaScript entry point.
 */
import '../scss/main.scss';
import { initNavigation } from './navigation.js';
import { initMicrositeNav } from './microsite-nav.js';
import { initSectionNav } from './section-nav.js';
import { initBlocks } from './blocks.js';
import { initScrollControl } from './scroll-control.js';
import { initInfiniteScroll } from './infinite-scroll.js';
import { initElpArchiveFilters } from './elp-archive.js';

// Show FacetWP facet sections only when they have choices.
// Facets with [data-facet] are visually hidden by default via CSS.
// Truly empty facets get .is-empty to collapse them.
const showPopulatedFacets = () => {
	document.querySelectorAll('.whf-archive-layout__facet[data-facet]').forEach((el) => {
		const facetEl = el.querySelector('.facetwp-facet');
		if ( ! facetEl ) {
			return;
		}
		const hasChoices = facetEl.querySelector('.facetwp-checkbox, .facetwp-radio, option, .facetwp-selection-value');
		if ( hasChoices ) {
			el.classList.remove('is-empty');
			el.classList.add('is-visible');
		} else {
			el.classList.remove('is-visible');
			el.classList.add('is-empty');
		}
	});
};

// Update the "Show X results" button count from the hidden facet.
const updateResultsCount = () => {
	const source = document.querySelector('.whf-archive-layout__results-facet');
	const target = document.querySelector('.whf-archive-layout__show-results-count');
	if ( source && target ) {
		const count = source.textContent.trim();
		target.textContent = count;
	}
};

// Show the "Clear filters" button only when one or more filter facets are
// active (ignoring pagination), and reset everything on click.
const updateClearButton = () => {
	const btn = document.querySelector('[data-whf-clear-facets]');
	// FWP exists whenever FacetWP's script is enqueued (site-wide), but
	// buildQueryString() reads per-facet config that only exists once FacetWP
	// has actually loaded — guard on FWP.loaded or it throws on non-facet pages.
	if ( ! btn || typeof FWP === 'undefined' || ! FWP.loaded || typeof FWP.buildQueryString !== 'function' ) {
		return;
	}
	const params = new URLSearchParams(FWP.buildQueryString());
	params.delete('_paged');
	btn.hidden = 0 === [...params.keys()].length;
};

const initClearButton = () => {
	const btn = document.querySelector('[data-whf-clear-facets]');
	if ( ! btn ) {
		return;
	}
	btn.addEventListener('click', () => {
		if ( typeof FWP !== 'undefined' && typeof FWP.reset === 'function' ) {
			FWP.reset();
		}
	});
};

// Register facetwp-loaded listener immediately (before DOMContentLoaded)
// so we never miss the first fire.
document.addEventListener('facetwp-loaded', () => {
	showPopulatedFacets();
	updateResultsCount();
	updateClearButton();
});

document.addEventListener('DOMContentLoaded', () => {
	initNavigation();
	initMicrositeNav();
	initSectionNav();
	initBlocks();
	initClearButton();
	initScrollControl();
	initInfiniteScroll();
	initElpArchiveFilters();

	// If FacetWP already fired before this script loaded, run now.
	if ( typeof FWP !== 'undefined' ) {
		showPopulatedFacets();
		updateClearButton();
	}
});
